module.exports = "<span data-ng-message=required>*Required</span> <span data-ng-message=pattern>*Invalid Phone Number</span> ";